import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "fixed z-50 right-6 top-6 w-[360px] max-w-[calc(100vw-3rem)]" }

import Toast from '@/components/layout/Toast.vue'
import { useToast } from '@/composables/ui/useToast'


export default /*@__PURE__*/_defineComponent({
  __name: 'ToastContainer',
  setup(__props) {

const { toasts, removeToast } = useToast()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_TransitionGroup, {
      tag: "div",
      class: "space-y-3",
      "enter-active-class": "transition duration-200 ease-out",
      "enter-from-class": "opacity-0 translate-y-2",
      "enter-to-class": "opacity-100 translate-y-0",
      "leave-active-class": "transition duration-200 ease-in",
      "leave-from-class": "opacity-100 translate-y-0",
      "leave-to-class": "opacity-0 translate-y-2"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(toasts), (toast) => {
          return (_openBlock(), _createBlock(Toast, {
            key: toast.id,
            show: true,
            type: toast.type,
            title: toast.title,
            message: toast.message,
            onClose: ($event: any) => (_unref(removeToast)(toast.id))
          }, null, 8, ["type", "title", "message", "onClose"]))
        }), 128))
      ]),
      _: 1
    })
  ]))
}
}

})